import React, { useState, useEffect } from 'react';
import Picker from "../Picker";
import { buildDate, datePickerDateOptions } from "../../../modules/dates";
function getDateValue(resource, name, defaultDate) {
    let date = defaultDate;
    if (resource && resource[name]) {
        date = resource[name];
    }
    if (typeof date !== 'string') {
        return date;
    }
    if (date.indexOf('-') >= 0) {
        return new Date(date);
    } // Sometimes we'll receive a date as a string we can't just pass to the Date constructor:
    const parts = date.split(' ').reverse();
    const year = parts[0];
    const month = parseInt(parts[1], 10) - 1; // Months are counted from 0
    const day = parts[2];
    return new Date(Number(year), month, Number(day), 0, 0, 0, 0);
}
function getStateFromProps(resource, name, defaultDate, includeDay) { const dateValue = getDateValue(resource, name, defaultDate); const state = { day: null, month: 0, year: null }; if (dateValue) {
    if (includeDay) {
        state.day = dateValue.getDate();
    }
    state.month = dateValue.getMonth();
    state.year = dateValue.getFullYear();
} return state; }
export default function DatePicker({ defaultDate, defaultDay = 'first', includeDay, maxYear, minDate, minYear, name, onChange, onComplete, resource, showNav }) {
    const initialState = getStateFromProps(resource, name, defaultDate, includeDay);
    const [day, setDay] = useState(initialState.day);
    const [month, setMonth] = useState(initialState.month);
    const [year, setYear] = useState(initialState.year); // Reset state when name changes or when value needs clearing
    useEffect(() => { const dateValue = getDateValue(resource, name, defaultDate); const valueNeedsClearing = !dateValue && year; if (valueNeedsClearing) {
        const newState = getStateFromProps(resource, name, defaultDate, includeDay);
        setDay(newState.day);
        setMonth(newState.month);
        setYear(newState.year);
    } }, [resource, name, defaultDate, includeDay, year]); // Reset when name changes
    useEffect(() => { const newState = getStateFromProps(resource, name, defaultDate, includeDay); setDay(newState.day); setMonth(newState.month); setYear(newState.year); }, [name]);
    const handleChange = partialState => { const newDay = partialState.day !== undefined ? partialState.day : day; const newMonth = partialState.month !== undefined ? partialState.month : month; const newYear = partialState.year !== undefined ? partialState.year : year; setDay(newDay); setMonth(newMonth); setYear(newYear); onChange({ [name]: buildDate(newDay, newMonth, newYear, defaultDay) }); };
    const handleComplete = () => { const newState = getStateFromProps(resource, name, defaultDate, includeDay); setDay(newState.day); setMonth(newState.month); setYear(newState.year); onComplete(); };
    return /*#__PURE__*/ React.createElement(Picker, { name: name, onChange: handleChange, options: datePickerDateOptions(day, month, year, minDate, minYear, maxYear, includeDay), onComplete: handleComplete, showNav: showNav });
}
